import { action } from '@ember/object';
import Component from '@glimmer/component';

interface UiInputGroupStringListSignature {
  Element: HTMLDivElement;
  Args: {
    Named: {
      id: string;
      ariaDescribedby?: string;
      hasError?: boolean;
      values?: string[];
      inputType?: string;
      placeholder?: string;
      addLabel: string;
      removeLabel: string;
      onChange: (values: string[]) => void;
      onBlur?: () => void;
    };
  };
}

export default class UiInputGroupStringListComponent extends Component<UiInputGroupStringListSignature> {
  get values() {
    return this.args.values ?? [];
  }

  get labelId() {
    return `${this.args.id}-label`;
  }

  @action
  updateValueAt(index: number, event: Event) {
    const { value } = event.currentTarget as HTMLInputElement;

    this.args.onChange(
      this.values.map((existing, at) => (at === index ? value : existing))
    );
  }

  @action
  removeValueAt(index: number) {
    this.args.onChange(this.values.filter((_, at) => at !== index));
  }

  @action
  addValue() {
    this.args.onChange([...this.values, '']);
  }

  @action
  handleBlur() {
    this.args.onBlur?.();
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Ui::InputGroup::StringList': typeof UiInputGroupStringListComponent;
    'ui/input-group/string-list': typeof UiInputGroupStringListComponent;
  }
}
